import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RTA_CODES } from '../components/dashboard/commercial/emandate/types';
import { fetchInvestorDetails } from '../redux-store/actions/nct';
import { RootStateType } from '../redux-store/reducers';
import { IsAllow } from '../redux-store/types/portfolio';

export type BankDetailsType = {
    accountNo: string;
    accountType: string;
    branch: string;
    city: string;
    ifsc: string;
    micr: string;
    name: string;
    neftIfsc: string;
    pincode: string;
    default: IsAllow;
};

export const bankDetailsInitState: BankDetailsType = {
    accountNo: '',
    accountType: '',
    branch: '',
    city: '',
    ifsc: '',
    micr: '',
    name: '',
    neftIfsc: '',
    pincode: '',
    default: IsAllow.No,
};

const moveToFirst = (bankArray: BankDetailsType[]) => {
    const defaultBank: BankDetailsType = bankArray.find((bank) => bank.default === IsAllow.YES)!;
    const remainingBanks = bankArray.filter((bank) => bank.default !== IsAllow.YES);
    return [defaultBank, ...remainingBanks];
};

const getDefaultBank = (bankArray: BankDetailsType[]) => {
    const defaultBank: BankDetailsType[] = bankArray.filter(
        (bank) => bank.default === IsAllow.YES,
    )!;
    return defaultBank;
};
export const useBank = (
    portfolioData: any,
    folioNo: string,
    currentAmcCode: string,
    redemptionFlag: boolean,
): [
    BankDetailsType[],
    BankDetailsType,
    React.Dispatch<React.SetStateAction<BankDetailsType>>,
    boolean,
] => {
    const [bankObjects, setBankObjects] = React.useState<BankDetailsType[]>([]);
    const [bankDetails, setBankDetails] = React.useState<BankDetailsType>(bankDetailsInitState);
    const [invApiLoading, setLoading] = React.useState<boolean>(false);
    const [investorDetails, setInvDetails] = React.useState<any>(null);
    const history = useHistory();
    const { pan, mobile, pekrn, reqId, kycVerified } = useSelector((state: RootStateType) => {
        return {
            ...state.authReducer,
            ...state.newPurchase
        };
    });
    const dispatch = useDispatch();
    React.useEffect(() => {
        async function callApi() {
            try {
                setLoading(true);
                const payload = {
                    pan,
                    mobile,
                    pekrn,
                    reqId,
                };
                const { body = {} } = (await dispatch(fetchInvestorDetails(payload))) as any;
                setInvDetails(body.success);
                const currentFolioDetails = body.success 
                    .find((amcDetails: any) => amcDetails.amc == currentAmcCode)
                    .investorDetails.find((currentInvFolio: any) => {
                        return currentInvFolio.folio == folioNo;
                    });
                const bankArray = currentFolioDetails.bank;
                const rtaName = currentFolioDetails.rtaName;

                if (rtaName == RTA_CODES.CAMS && redemptionFlag) {
                    setBankObjects(getDefaultBank(bankArray));
                } else {
                    setBankObjects(moveToFirst(bankArray));
                }
            } catch (err: any) {
                alert(err.message);
                history.goBack();
            } finally {
                setLoading(false);
            }
        }
        if (folioNo && kycVerified.value === IsAllow.YES) {
            if (!investorDetails) {
                callApi();
            } else {
                const currentFolioDetails = investorDetails
                    .find((amcDetails: any) => amcDetails.amc == currentAmcCode)
                    .investorDetails.find((currentInvFolio: any) => {
                        return currentInvFolio.folio == folioNo;
                    });

                const bankArray = currentFolioDetails.bank;
                const rtaName = currentFolioDetails.rtaName;

                if (rtaName == RTA_CODES.CAMS && redemptionFlag) {
                    setBankObjects(getDefaultBank(bankArray));
                } else {
                    setBankObjects(moveToFirst(bankArray));
                }
            }
        }
    }, [folioNo, kycVerified.value]);

    // React.useEffect(() => {
    //     let currentAmcSchemes = portfolioData?.find(
    //         (amc: any) => amc.summary['non_demat']?.amc === currentAmcCode,
    //     )?.schemes;
    //     let bankObjects: BankDetailsType[] = currentAmcSchemes?.reduce((acc: any, scheme: any) => {
    //         if (scheme.folio == folioNo && !!scheme.bank?.ifsc) {
    //             let accountNumbers = acc.map((bank: any) => bank?.accountNo);
    //             if (!accountNumbers?.includes(scheme?.bank?.accountNo)) {
    //                 return [...acc, scheme.bank];
    //             } else return acc;
    //         } else return acc;
    //     }, []);
    //     bankObjects = bankObjects?.filter((bank: any) => bank !== undefined);
    //     setBankObjects(bankObjects);
    // }, [investorBanks]);

    React.useEffect(() => {
        if (bankObjects?.length > 0) setBankDetails(bankObjects[0]);
    }, [bankObjects]);

    return [bankObjects, bankDetails, setBankDetails, invApiLoading];
};
